
/* eslint-disable @typescript-eslint/quotes */

// This file is auto-generated.

export default {
  "BUILD_TIMESTAMP": "2026-09-11T10:51:23.938Z",
  "SENTRY_DSN": "https://83e8f50ec8694629b8705a53a3c69096@sentry.runbox.com/2"
};